<template>
  <fragment>
    <form action="" class="store-form search-form" :class="{'has-focused' : isFocused && !isSelectShown}">
      <div class="store-form__item">
        <div
            class="input-wrap has-search"
            :class="{
            'has-filled': formSearch.search.length,
            'has-error': $v.formSearch.search.$error,
          }"
        >
          <label class="input-wrap__label" for="search"
          >{{ options.searchForm.label }}</label
          >
          <input
              id="search"
              class="input-wrap__input"
              type="text"
              :placeholder="options.searchForm.placeholder"
              v-model="formSearch.search"
              ref="autocomplete"
              @input="handleChange"
              @keydown.enter="handleSearch"
          />
          <input type="hidden" name="latitude" v-model="formSearch.latitude" value=""/>
          <input type="hidden" name="longitude" v-model="formSearch.longitude" value=""/>
          <button-theme
              :type="`submit`"
              :mode="`transparent`"
              :size="`xs`"
              :name="options.searchForm.button"
              @handleClick="handleSearch"
          />
        </div>
      </div>
    </form>

    <div class="store-no-results">
      <div class="store-no-results__wrapper" v-if="shownNoRetailers">
        <block-heading :selector="`store-no-results`" :title="options.global.no_found_title" :text="options.global.no_found_text"/>
      </div>
    </div>

    <form action="" class="store-form retailers-form"
          :class="{'has-focused': isOpen && isSelectShown && !isUserDataShown}"
          ref="retailersForm">
      <div v-if="isSelectShown" class="store-form__item" >
        <div
            class="input-wrap"
            :class="{
            'has-filled': formRetailers.selected.length,
            'has-error': $v.formRetailers.selected.$error,
          }"
        >
          <label for="select" class="input-wrap__label">{{ options.form.select }}</label>
          <div class="input-wrap__icon icon">
            <caret-bottom-svg/>
          </div>
          <div class="input-wrap__input has-select" @click="toggleClick"
               v-click-outside="hideSelect">
            <input
                id="select"
                type="text"
                disabled
                :placeholder="options.form.select_placeholder"
                v-model="formRetailers.selected"
            />
            <custom-select
                :options="shownRetailers"
                :is-open="isOpen"
                @input="handleSelect"
            />
          </div>
        </div>
      </div>
      <div v-if="isSelectShown && isUserDataShown" class="store-form__item has-multiple">
        <div
            class="input-wrap"
            :class="{
            'has-filled': formRetailers.name.length,
            'has-error': $v.formRetailers.name.$error,
          }"
        >
          <label class="input-wrap__label" for="name">{{ options.form.name }}*</label>
          <input
              autocomplete="off"
              id="name"
              name="name"
              class="input-wrap__input"
              type="text"
              :placeholder="options.form.name_placeholder"
              v-model="formRetailers.name"
          />
        </div>
        <div
            class="input-wrap"
            :class="{
            'has-filled': formRetailers.surname.length,
            'has-error': $v.formRetailers.surname.$error,
          }"
        >
          <label class="input-wrap__label" for="surname">{{ options.form.surname }}*</label>
          <input
              autocomplete="off"
              id="surname"
              name="surname"
              class="input-wrap__input"
              type="text"
              :placeholder="options.form.surname_placeholder"
              v-model="formRetailers.surname"
          />
        </div>
        <div
            class="input-wrap"
            :class="{
            'has-filled': formRetailers.email.length,
            'has-error': $v.formRetailers.email.$error,
          }"
        >
          <label class="input-wrap__label" for="email">{{ options.form.email }}*</label>
          <input
              autocomplete="off"
              id="email"
              name="email"
              class="input-wrap__input"
              type="text"
              :placeholder="options.form.email_placeholder"
              v-model="formRetailers.email"
          />
        </div>
        <div
            class="input-wrap"
            :class="{
            'has-filled': formRetailers.phone.length,
          }"
        >
          <label class="input-wrap__label" for="phone">{{ options.form.phone }}</label>
          <input
              autocomplete="off"
              id="phone"
              name="phone"
              class="input-wrap__input"
              type="tel"
              :placeholder="options.form.phone_placeholder"
              v-model="formRetailers.phone"
              @keydown="handleKeydown"
          />
        </div>
        <button-theme
            :type="`submit`"
            :mode="`fill`"
            :size="`s`"
            :name="options.form.submit"
            @handleClick="handleSubmit"
        />
      </div>
    </form>
  </fragment>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import {minLength, required, email} from 'vuelidate/lib/validators';
import blockHeading from './blockHeading.vue';
import buttonTheme from './buttonTheme.vue';
import customSelect from './customSelect.vue';
import CaretBottomSvg from '../../../../../assets/img/icons/caret-bottom.svg';
import axios from "axios";
import * as qs from "qs";

export default {
  name: 'resultForm',
  components: {
    blockHeading,
    buttonTheme,
    CaretBottomSvg,
    customSelect,
  },
  data() {
    return {
      formSearch: {
        search: '',
        latitude: '',
        longitude: '',
      },
      formRetailers: {
        selected: '',
        name: '',
        surname: '',
        email: '',
        phone: '',
      },
      loading: false,
      successSearch: false,
      success: false,
      isOpen: false,
      isShown: false,
      isSelectShown: false,
      isUserDataShown: false,
      popupMode: 'thanks',
      retailers: [],
      shownRetailers: [],
      shownNoRetailers: false,
      retailerEmail: '',
      isFocused: false,
    };
  },
  validations: {
    formSearch: {
      search: {
        required,
        minLength: minLength(1),
      },
      latitude: required,
      longitude: required,
    },
    formRetailers: {
      selected: {
        required,
        minLength: minLength(2),
      },
      name: {
        required,
        minLength: minLength(2),
      },
      surname: {
        required,
        minLength: minLength(2),
      },
      email: {
        required,
        email,
      },
    },
  },
  directives: {
    ClickOutside
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
  },
  created() {
    this.retailers = this.options.retailers;
  },
  methods: {
    toggleClick() {
      this.isOpen = !this.isOpen;
    },
    resetSearch() {
      this.shownRetailers = [];
      this.shownNoRetailers = false;
      this.isSelectShown = false;
    },
    handleChange() {
      this.resetSearch();
      this.isFocused = this.formSearch.search !== '';

      let geocoder, autocomplete;

      const codeAddress = (address) => {
        geocoder.geocode({
          'address': address
        }, (results, status) => {
          if (status === 'OK') {
            this.formSearch.search = address;
            this.formSearch.latitude = results[0].geometry.location.lat();
            this.formSearch.longitude = results[0].geometry.location.lng();
            this.successSearch = true;
          } else {
            console.log('Geocode was not successful for the following reason: ' + status);
          }
        });
      }

      const fillInAddress = () => {
        const place = autocomplete.getPlace();
        codeAddress(this.$refs.autocomplete.value);
      }

      const initAutocomplete = () => {
        geocoder = new google.maps.Geocoder();
        autocomplete = new google.maps.places.Autocomplete(
            (this.$refs.autocomplete), {
              types: ['geocode']
            });

        autocomplete.addListener('place_changed', fillInAddress);
      }
      initAutocomplete();
    },
    nearestCity(lat1, lon1, lat2, lon2, retailer) {
      let radLat1 = Math.PI * lat1 / 180
      let radLat2 = Math.PI * lat2 / 180
      let theta = lon1 - lon2
      let radTheta = Math.PI * theta / 180
      let dist = Math.sin(radLat1) * Math.sin(radLat2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);
      if (dist > 1) dist = 1;
      dist = Math.acos(dist)
      dist = dist * 180 / Math.PI
      dist = dist * 60 * 1.1515
      dist = dist * 1.609344;

      if (dist < 600) {
        this.shownRetailers.push(retailer);
      }
    },
    handleSearch(event) {
      event.preventDefault();

      this.$v.formSearch.$touch();
      if (!this.$v.formSearch.$invalid && this.successSearch) {
        this.retailers.forEach(retailer => {
          this.nearestCity(this.formSearch.latitude, this.formSearch.longitude, retailer.lat, retailer.lng, retailer);
        });
        if (this.shownRetailers && this.shownRetailers.length) {
          this.isSelectShown = true;
          this.shownNoRetailers = false;
        } else {
          this.isSelectShown = false;
          this.shownNoRetailers = true;
        }
      }
    },
    handleSelect(event) {
      this.formRetailers.selected = event.name;
      this.retailerEmail = event.email;
      this.isUserDataShown = true;

      this.$store.commit('selectedRetailer', event);
    },
    hideSelect() {
      this.isOpen = false;
    },
    handleKeydown(event) {
      const char = String.fromCharCode(event.keyCode);
      if (/^[A-Z]+$/i.test(char)) {
        event.preventDefault();
      }
    },
    handleSubmit(event) {
      event.preventDefault();

      this.$v.formRetailers.$touch();
      if (!this.$v.formRetailers.$invalid) {
        this.sendForm();
      }
    },
    sendForm() {
      let data = {
        action: 'send_retailers_email',
        name: this.formRetailers.name,
        surname: this.formRetailers.surname,
        email: this.formRetailers.email,
        phone: this.formRetailers.phone,
        retailer_email: this.retailerEmail,
        selected_items: this.$store.state.selectedResult.model
      };
      axios({
        async: false,
        method: 'post',
        url: app.ajax_url,
        data: qs.stringify(data),
      }).then(response => {

        this.$emit('success');

      }).catch(() => {
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/setup.scss';

.store-form {
  padding: 50px 16px 0;

  @include up-tablet {
    padding-right: 0;
    padding-left: 0;
  }

  @include up-desktop {
    padding-top: 79px;
  }

  &.search-form {
    &.has-focused {
      margin-bottom: 90px;
    }
  }

  &.retailers-form {
    padding-top: 26px;

    @include up-tablet {
      padding-top: 42px;
    }

    &.has-focused {
      margin-bottom: 210px;
    }
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: 26px;

      @include up-tablet {
        margin-bottom: 42px;
      }
    }

    &:first-child {
      .input-wrap {
        &__label {
          margin-bottom: 11px;

          @include up-tablet {
            margin-bottom: 0;
          }
        }
      }
    }

    &.has-multiple {
      @include up-tablet {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 26.5px;
        grid-row-gap: 42px;
      }

      .input-wrap {
        &:not(:last-of-type) {
          margin-bottom: 26px;

          @include up-tablet {
            margin-bottom: 0;
          }
        }
      }

      .button-theme {
        margin-top: 39px;

        @include up-tablet {
          grid-column: 1/3;
          margin: 12.25px auto 0;
          max-width: 229px;
        }
      }
    }
  }

  .input-wrap {
    position: relative;
    width: 100%;
    border-bottom: 1px solid $c-black;
    @include anim();

    &.has-error {
      border-bottom-color: red;
    }

    &.has-search {
      input {
        padding-right: 100px;
      }

      .button-theme {
        position: absolute;
        right: 0;
        bottom: 7.24px;
        z-index: 1;

        @include up-tablet {
          bottom: 18.24px;
        }
      }
    }

    &__label {
      display: block;
      margin-bottom: 3px;
      font-family: $f-bellStd;
      font-weight: 400;
      font-size: 18px;
      line-height: 22px;
      letter-spacing: 0.135px;

      @include up-tablet {
        margin-bottom: 0;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0.15px;
      }
    }

    &__input {
      margin-top: 2px;
      width: 100%;
      height: 2em;
      font-family: $f-neutraBook;
      font-weight: 400;
      font-size: 14px;
      line-height: 1.1;
      letter-spacing: 0.35px;

      &.has-select {
        cursor: pointer;

        input {
          padding-right: 35px;
          width: 100%;
          height: 100%;
          text-overflow: ellipsis;
          color: currentColor;
        }
      }
    }

    &__icon {
      position: absolute;
      right: 13.4px;
      bottom: 12.4px;
      width: 9.48px;
      height: 5.09px;
      display: flex;
      pointer-events: none;

      @include up-tablet {
        right: 11.15px;
        bottom: 11.06px;
      }
    }
  }
}

.store-no-results {
  &__wrapper {
    padding: 50px 16px;
  }

  &__heading {
    &.heading {
      margin-bottom: .5em;
      font-size: 20px;

      @include up-tablet {
        font-size: 20px;
      }
    }
  }
}
</style>
